import { theme } from "@chakra-ui/react"

interface TagColor {
  name: string
  color: string
}

export const tagColors: TagColor[] = [
  { name: "Gray", color: theme.colors.gray[200] },
  { name: "Red", color: theme.colors.red[200] },
  { name: "Orange", color: theme.colors.orange[200] },
  { name: "Yellow", color: theme.colors.yellow[200] },
  { name: "Green", color: theme.colors.green[200] },
  { name: "Teal", color: theme.colors.teal[200] },
  { name: "Blue", color: theme.colors.blue[200] },
  { name: "Cyan", color: theme.colors.cyan[200] },
  { name: "Purple", color: theme.colors.purple[200] },
  { name: "Pink", color: theme.colors.pink[200] },
]
